import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import './CustomerModals.scss'

function RoleChange({ userData, fetchUser, setShowRole }: any) {
  const { id } = useParams()
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [role, setRole] = useState(userData.role)

  async function changeRole() {
    const data = {
      role: role,
    }
    if (role.length < 4) {
      notify('warn', 'Pick a role')
      return
    }
    setCancelLoading(true)
    put(`admin/change-role/${id}`, data)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Customer role Updated')
          setShowRole(false)
          fetchUser()
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div className='modal-icon icon-blue'>
            <Icon icon='mdi:account-convert-outline' />
          </div>
          <h2>Change Customer Role</h2>
          <p>This will update the user's role and adjust their system access accordingly.</p>
        </div>

        <div className='form-group'>
          <label>Select New Role</label>
          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value=''>— Select role —</option>
            <option value='aggregator'>Aggregator</option>
            <option value='super-aggregator'>Super Aggregator</option>
            <option value='special'>Special</option>
            <option value='trusted-user'>Trusted User</option>
            <option value='user'>User</option>
          </select>
        </div>

        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={() => setShowRole(false)}>
              Cancel
            </button>
            <button className='btn-proceed' onClick={changeRole}>
              Update Role
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default RoleChange
